// extracted by mini-css-extract-plugin
module.exports = {"ModalContainer":"style_ModalContainer__1Th4s","CloseBtn":"style_CloseBtn__2CZSm","Body":"style_Body__3bF-b","ModalTitle":"style_ModalTitle__L21f2"};